import * as yup from 'yup';

const PartsRequestSchema = yup.object().shape({
    description: yup.string().required().max(50),
    notes: yup.string().max(250),
});

export default PartsRequestSchema;
